export default "__VITE_ASSET__CQqGfevH__"